import { createContext } from 'react';

export const PlayerOpenContext = createContext<
  [string, React.Dispatch<React.SetStateAction<string>>]
>(['', () => {}]);
